import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ConfigService } from './config.service';

// Define interface for responsibles data
export interface Responsible {
  id: string;
  name: string;
  email: string;
  role: string;
}

@Injectable({
  providedIn: 'root'
})
export class ResponsiblesService {
  private http = inject(HttpClient);
  configService = inject(ConfigService);

  /**TODO typing */
  getResponsibles(lu: string): Observable<Responsible[]> {
    return this.http.get<Responsible[]>(
      `${this.configService.getConfiguration().apiHost}/api/organizations/responsibles/${lu}`
    );
  }
}
